import axios from 'axios'
var userPeerConnectionMap = new Map(); //用户名和peerConnection对应关系
var username; //登录用户唯一凭证
var userOnlineList; //在线用户
var socket; //websocket链接
var msg; //需要发送的消息
//本地视频流
var locatStream = null;
//本地音频流
var locatAudioStream = null;
//webrtc连接通道
var localPeerConnection = null;
//穿透服务器
// var config = {
//     'iceServers': [
//         { 'url': 'stun:stun.l.google.com:19302' }
//     ]
// };
// config = {
//     iceServers: [
//         { urls: 'stun:stun.l.google.com:19302' },
//         { urls: 'stun:global.stun.twilio.com:3478?transport=udp' }
//     ],
// };
var config = {
  iceServers: [{
    urls: [
      // "stun:47.94.101.45:3478",
      "turn:fourdsoft.cn:33478",
    ],
    username: "wetrtc",
    credential: "webrtc123"
  }],
  iceTransportPolicy: "relay"
};
//流连接通道
var PeerConnection = (window.webkitRTCPeerConnection || window.mozRTCPeerConnfection || window.RTCPeerConnection ||
  undefined);
//RTC信令
var RTCSessionDescription = (window.webkitRTCSessionDescription || window.mozRTCSessionDescription || window
  .RTCSessionDescription || undefined);
//摄像头对象
navigator.getUserMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia ||
  navigator.msGetUserMedia);
// const remoteVideo = document.getElementById('localVideo');
var remoteVideo, remoteAudio
window.onload = function() {
  remoteVideo = document.getElementById('video1');
  remoteAudio = document.querySelector('audio');
}

var isBeVideo = false; //屏幕是否正在投屏 true 已投 false 未投
var isBeVideoLoad = true;

var this_ = ''; //test vue实例

export function getLoginUserInfoDataFn(val) {
  this_ = val
  // webrtc
  axios.post(`/webrtc/login/get_login_user_info_data`)
    .then(res => {
      console.log('res=>', res.data.name);
      username = res.data.name;
      this_.username = res.data.name
      //建立websocket链接
      var WebSocketUrl = 'ws://' + location.host + "/webrtc/websocket2/" + username
       if ("https:" == document.location.protocol) {
           WebSocketUrl = 'wss://' + location.host + "/webrtc/websocket2/" + username
       }
      socket = new WebSocket(WebSocketUrl);

      // socket = new WebSocket("ws://192.168.31.204:39999/webrtc/websocket2/" + username);

      // socket = new WebSocket("wss://multi-online.fourdsoft.cn/webrtc/websocket2/" + username);
      socketFn()
      remoteAudioFn(); //初始化 音频

      setTimeout(() => {
        isBeVideoLoad = false
      }, 5000)
    })
}


// $.ajax({//需要后台请求获取登录用户名
// 	url:'http://192.168.31.66:8080/webrtc/login/get_login_user_info_data',
// 	type:'POST',
// 	dataType:'json',
// 	success:function(data){
// 		username=data.name;
// 		//建立websocket链接
// 		// socket = new WebSocket("wss://"+document.location.host+"/websocket/"+username);
// 		socket = new WebSocket("ws://192.168.31.66:8080/webrtc/websocket2/"+username);
// 		init();//在确认登录用户后初始化
// 	}
// })
//初始化 音频
export function remoteAudioFn() {
  console.log('navigator:', navigator)
  navigator.getUserMedia({
    "audio": true,
    "video": false
  }, function success(stream) {
    console.log('音频stream:', stream)
    // document.getElementById("localVideo").src = window.URL.createObjectURL(stream);//本地画面投影
    locatStream = null
    locatAudioStream = stream; //保存流通道
    readyToConnection(); //准备向在线用户发送连接请求
  }, function error(error) {
    // console.log(error);
    readyToConnection(); //准备向在线用户发送连接请求
  });

  // if (!isTouchscreenDevice()) { //手机
  //   navigator.getUserMedia({
  //     "audio": true,
  //     "video": false
  //   }, function success(stream) {
  //     console.log('音频stream:', stream)
  //     // document.getElementById("localVideo").src = window.URL.createObjectURL(stream);//本地画面投影
  //     locatStream = null
  //     locatAudioStream = stream; //保存流通道
  //     readyToConnection(); //准备向在线用户发送连接请求
  //   }, function error(error) {
  //     // console.log(error);
  //   });
  // }
}
//投屏 共享屏幕
export function sharedScreenFn(videoIndex) {
  //显示摄像头画面
  // 	navigator.getUserMedia({
  // 			"audio": true,
  // 			"video": false
  // 		},function success(mediaStream){
  // 			// document.getElementById("localVideo").src = window.URL.createObjectURL(stream);//本地画面投影
  // 			locatStream=mediaStream;//保存流通道
  // 			readyToConnection();//准备向在线用户发送连接请求
  // 		},function error(error){
  // 			console.log(error);
  // 		}
  // 	);
  if (isBeVideoLoad) {
    return
  }
  if (isBeVideo) {
    alert('该屏幕已被使用')
    return
  }

  //显示投屏画面
  const options = {
    audio: true,
    video: true
  };
  // console.log('摄像头对象:', navigator)
  navigator.mediaDevices.getDisplayMedia(options).then(handleSuccess, handleError);

  function handleSuccess(stream) {
    stream.getVideoTracks()[0].onended = async () => {
      //单击停止共享按钮后，触发这个事件
      console.log('单击停止共享按钮后')
      locatStream = null
      msg = JSON.stringify({ //停止录屏
        'type': "closeVideo",
      });
      socket.send(msg);

      remoteAudioFn(); //初始化 音频
      readyToConnection();//准备向在线用户发送连接请求
    }
    if (locatStream) { //停止上一次录制
      locatStream.getTracks()
        .forEach(track => track.stop())
    }
    locatAudioStream = null; //清空音频
    console.log('视频stream:', stream)
    // document.getElementById("localVideo").src = window.URL.createObjectURL(stream);//本地画面投影
    locatStream = stream; //保存流通道

    readyToConnection(); //准备向在线用户发送连接请求

    // remoteVideo.srcObject = stream; //显示共享屏幕
    console.log('videoIndex',videoIndex)
    //投影对应的屏幕
    if (videoIndex == 'video1') {
      isBeVideo = true;
      this_.createBillboardVideo(
        0,
        220,
        -495,
        Math.PI * 2,
        stream,
        'https://baidu.com',
        'video1'
      );
    } else if (videoIndex == 'video2') {
      this_.createBillboardVideo(
        495,
        200,
        0,
        Math.PI / 2 * 3,
        stream,
        'https://baidu.com',
        'video2'
      );
    } else if (videoIndex == 'video3') {
      this_.createBillboardVideo(
        -495,
        200,
        0,
        Math.PI / 2 * 1,
        stream,
        'https://baidu.com',
        'video3'
      );
    } else if (videoIndex == 'video4') {
      this_.createBillboardVideo(
        0,
        200,
        495,
        Math.PI,
        stream,
        'https://baidu.com',
        'video4'
      )
    }

  }

  function handleError(error) {
    // console.log('error:', error);
  }
}
//准备向在线用户发送连接请求
export function readyToConnection() {
  // console.log('readyToConnection', socket, msg)
  //向socket服务器发送请求得到在线用户

  msg = JSON.stringify({
    'type': 'getOnlineUserName'
  });
  socket.send(msg);

  //回复消息onmessage type:userOnlineList
  //1.回复消息时初始化Video框
  //2.初始化username和peerConnection对应关系
  //3.初始化peerConnection绑定视频流addStream
  //4.遍历peerConnection发送Offer
}
//webSocke
export function socketFn() {
  socket.onopen = function() {
    console.log("webSocke连接成功");
    // remoteAudioFn()
    // readyToConnection()
    // if (isTouchscreenDevice()) {
    //   readyToConnection();
    // }
  };
  socket.onerror = function(e) {
    console.log('webSocke错误信息', e);
  };
  //
  socket.onclose = function(event) {
    console.log(`websocket断开，代码：${event.code}，原因：${event.reason}`);
    // 尝试重新连接
    setTimeout(function() {
      var WebSocketUrl = 'ws://' + location.host + "/webrtc/websocket2/" + username
       if ("https:" == document.location.protocol) {
           WebSocketUrl = 'wss://' + location.host + "/webrtc/websocket2/" + username
       }
      socket = new WebSocket(WebSocketUrl);
      // socket = new WebSocket("ws://192.168.31.204:39999/webrtc/websocket2/" + username);
      socketFn()
    }, 1000);
  };



  //收到消息
  socket.onmessage = function(Message) {
    console.log('webSocke收到消息:', Message, JSON.parse(Message.data))
    var jsonObj = JSON.parse(Message.data);
    var type = jsonObj.type;
    var data = jsonObj.data;
    switch (type) {
      case "offer":
        if (jsonObj.sendBy != username && userPeerConnectionMap.get(jsonObj.sendBy)) {
          // console.log('type offer')
          console.log('userPeerConnectionMap:', userPeerConnectionMap,'jsonObj.sendBy:', jsonObj.sendBy)
          localPeerConnection = userPeerConnectionMap.get(jsonObj.sendBy);
          console.log('localPeerConnection:', localPeerConnection)
          var rtcs = new RTCSessionDescription(data); //RTC信令
          localPeerConnection.setRemoteDescription(rtcs); //设置远程描述
          if (locatStream) {
            localPeerConnection.addStream(locatStream); //添加视频流
          }
          if (locatAudioStream) {
            localPeerConnection.addStream(locatAudioStream); //添加音频流
          }
          localPeerConnection.createAnswer(
            function(desc) {
              console.log('desc:', desc)
              // console.log('desc:', desc.sdp.split('\r\n'))
              console.log('localPeerConnection.signalingState状态-299',localPeerConnection.signalingState)
              localPeerConnection.setLocalDescription(desc);
              msg = JSON.stringify({
                'sendBy': username, //发送人
                'sendTo': jsonObj.sendBy, //接受人
                'type': "answer",
                'data': desc,
                'stream': locatStream ? 'videoStream' : 'audioStream'
              });
              socket.send(msg);
            },
            function(error) {});

          localPeerConnection.onicecandidate = function(event) {
            console.log("onicecandidate", event.candidate);
            msg = JSON.stringify({
              'sendBy': username, //发送人
              'sendTo': jsonObj.sendBy, //接受人
              'type': 'candidate', //候选人
              'data': event.candidate,
              'stream': locatStream ? 'videoStream' : 'audioStream'
            });
            socket.send(msg);
          }
          localPeerConnection.ontrack = event => {
            console.log("当远程媒体流ontrack 添加到连接后发送事件:", event);
            if (jsonObj.stream == 'audioStream') { //音频流
              try {
                remoteAudio.srcObject = event.streams[0];
              } catch (e) {
                remoteAudio = document.querySelector('audio');
                remoteAudio.srcObject = event.streams[0];
              }
              // console.log('onaddstream-设置音频流')
            } else if (jsonObj.stream == 'videoStream') { //视频流
              isBeVideo = true;
              this_.createBillboardVideo(
                0,
                220,
                -495,
                Math.PI * 2,
                event.streams[0],
                'https://baidu.com',
                'video1'
              );
            }
          };
        }
        // localPeerConnection.onaddstream = function(event) { //当远程媒体流MediaStream 添加到连接后发送事件
        //   console.log("当远程媒体流MediaStream 添加到连接后发送事件:", event);
        //   if (jsonObj.stream == 'audioStream') { //音频流
        //     try {
        //       remoteAudio.srcObject = event.stream;
        //     } catch (e) {
        //       remoteAudio = document.querySelector('audio');
        //       remoteAudio.srcObject = event.stream;
        //     }
        //     // console.log('onaddstream-设置音频流')
        //   } else if (jsonObj.stream == 'videoStream') { //视频流
        //     isBeVideo = true;
        //     this_.createBillboardVideo(
        //       0,
        //       200,
        //       -495,
        //       Math.PI * 2,
        //       event.stream,
        //       'https://baidu.com/被动接受时的onaddstream',
        //       'video1'
        //     );
        //   }
        // }
        break;

      case "answer": //回答
        console.log('type answer')
        var rtcs = new RTCSessionDescription(data); //RTC信令
        userPeerConnectionMap.get(jsonObj.sendBy).setRemoteDescription(rtcs);

        break;

      case "candidate": //候选人
        console.log('type candidate')
        if (data != null && userPeerConnectionMap.get(jsonObj.sendBy)) {
          console.log('userPeerConnectionMap-candidate', userPeerConnectionMap,'jsonObj.sendBy-candidate',jsonObj.sendBy)
          userPeerConnectionMap.get(jsonObj.sendBy).addIceCandidate(new RTCIceCandidate(data));
        }
        //localPeerConnection.addIceCandidate(new RTCIceCandidate(data));
        break;

      case "userOnlineList": //在线用户
        userOnlineList = data;
        console.log('在线用户:', data)
        if (data.length <= 1) {
          isBeVideoLoad = false
        }
        for (var i = 0; i < data.length; i++) {
          if (data[i] !== username) {
            //初始化username和peerConnection对应关系
            localPeerConnection = new PeerConnection(
              config); //获取视频标签，连接信令服务器，创建 RTCPeerConnection 对象。其中 RTCPeerConnection 的作用是在两个对等端之间建立连接，其构造函数支持传一个配置对象

            userPeerConnectionMap.set(data[i], localPeerConnection);
          }
        }
        // console.log('userPeerConnectionMap', userPeerConnectionMap)
        //遍历peerConnectionMap
        if (locatStream || locatAudioStream) {
          userPeerConnectionMap.forEach(function(value, key, map) {
            //遍历除自己以外的peerConnection
            if (key !== username) {
              console.log('locatStream:', locatStream)
              if (locatStream) {
                value.addStream(locatStream); //初始化绑定本地视频流
              }
              if (locatAudioStream) {
                value.addStream(locatAudioStream); //初始化绑定本地音频流
              }
              //发送offer
              value.createOffer( //创建offer
                function(offer) {
                  console.log('offer:', offer)
                  console.log('value.signalingState状态-425：', value.signalingState);
                  value.setLocalDescription(offer); //设置offer
                  msg = JSON.stringify({
                    'sendBy': username,
                    'sendTo': key,
                    'type': 'offer',
                    'data': offer,
                    'stream': locatStream ? 'videoStream' : 'audioStream'
                  });
                  socket.send(msg);
                  console.log("发送Offer");
                },
                function(error) {}
              )
              //绑定onicecandidate事件
              value.onicecandidate = function(event) { //交换 ICE 候选 通知连接的地址
                console.log("发送candidate",event);
                msg = JSON.stringify({
                  'sendBy': username,
                  'sendTo': key,
                  'type': 'candidate',
                  'data': event.candidate,
                  'stream': locatStream ? 'videoStream' : 'audioStream'
                });
                socket.send(msg);
              }
              // value.addEventListener('track', function(e) { //跟踪
              //   console.log("被动接受时的track" + locatStream ? 'videoStream' : 'audioStream' + ':', e);
              //   if (locatStream ? 'videoStream' : 'audioStream' == 'audioStream') { //音频流
              //     try {
              //       remoteAudio.srcObject = e.streams[0];
              //     } catch (err) {
              //       remoteAudio = document.querySelector('audio');
              //       remoteAudio.srcObject = e.streams[0];
              //     }
              //     console.log('track-设置音频流')
              //   } else if (locatStream ? 'videoStream' : 'audioStream' == 'videoStream') { //视频流
              //     isBeVideo = true;
              //     this_.createBillboardVideo(
              //       0,
              //       220,
              //       -495,
              //       Math.PI * 2,
              //       e.streams[0],
              //       'https://baidu.com',
              //       'video1'
              //     );
              //   }
              // });
            }
          });
        }
        break;

      case "userConnection":
        console.log("新增加视频用户:" + data)
        //新增username和peerConnection对应关系
        localPeerConnection = new PeerConnection(config);
        userPeerConnectionMap.set(data, localPeerConnection);
        if (locatStream || locatAudioStream) { //视频流
          setTimeout(() => {
            // readyToConnection(); //准备向在线用户发送连接请求

            if (data !== username) {
              console.log("准备向在线用户发送连接请求-新增加视频用户:" + data)
              var value = userPeerConnectionMap.get(data)
              console.log('locatStream:', locatStream)
              if (locatStream) {
                value.addStream(locatStream); //初始化绑定本地视频流
              }
              if (locatAudioStream) {
                value.addStream(locatAudioStream); //初始化绑定本地音频流
              }
              //发送offer
              value.createOffer( //创建offer
                function(offer) {
                  console.log('offer:', offer)
                  console.log('value.signalingState状态-507：', value.signalingState);
                  value.setLocalDescription(offer); //设置offer
                  msg = JSON.stringify({
                    'sendBy': username,
                    'sendTo': data,
                    'type': 'offer',
                    'data': offer,
                    'stream': locatStream ? 'videoStream' : 'audioStream'
                  });
                  socket.send(msg);
                  console.log("发送Offer");
                },
                function(error) {}
              )
              //绑定onicecandidate事件
              value.onicecandidate = function(event) { //交换 ICE 候选 通知连接的地址
                console.log("发送candidate");
                msg = JSON.stringify({
                  'sendBy': username,
                  'sendTo': data,
                  'type': 'candidate',
                  'data': event.candidate,
                  'stream': locatStream ? 'videoStream' : 'audioStream'
                });
                socket.send(msg);
              }
            }
          }, 5000)
        }

        break;

      case "userClose":
        console.log(data + "下线");
        //删除username和peerConnection对应关系
        userPeerConnectionMap.delete(data);
        var usernames;
        for (let key in this_.playerList) {
          if (this_.playerList[key].message.userid == data) {
            usernames = this_.playerList[key].message.username
          }
        }
        if (this_.scene && this_.scene.children.length > 0) {
          let index = this_.scene.children.findIndex(item => item.name == usernames)
          if (index >= 0) {
            this_.scene.children.splice(index, 1);
          }
        }

        var labelList = document.querySelectorAll('.label')
        if (labelList.length > 0) {
          labelList.forEach(item => {
            if (item.innerHTML == usernames) {
              item.style.display = "none"
            }
          })
        }

        if (this_.playerList[usernames]) {
          delete this_.playerList[usernames]
        }

        break;

      case "closeVideo": //关闭录屏
        console.log('关闭录屏')
        isBeVideo = false;
        this_.createBillboardVideo(
          0,
          220,
          -495,
          Math.PI * 2,
          '',
          'https://baidu.com',
          'video1'
        );
        break;
      default:
        console.log("default");
    }
  }
}

function gotRemoteStream(e) {
  if (remoteVideo.srcObject !== e.streams[0]) {
    remoteVideo.srcObject = e.streams[0];
    console.log('pc2 received remote stream');
  }
}

function deleteVideo(stream) {
  //locatStream.getVideoTracks()[0].stop();
}

export function isTouchscreenDevice() { //判断是否移动端
  let supportsTouch = false;
  if ("ontouchstart" in window)
    // iOS & android
    supportsTouch = true;
  else if (window.navigator.msPointerEnabled)
    // Win8
    supportsTouch = true;
  else if ("ontouchstart" in document.documentElement)
    // Controversial way to check touch support
    supportsTouch = true;

  return supportsTouch;
}

export function createJoystick(parent) { //创建移动端轮盘 绑定事件
  const maxDiff = 62; //how far drag can go
  // const stick = document.createElement("div");
  // //stick.classList.add("joystick");
  // stick.setAttribute("id", "joystick");

  const stick = document.getElementById("joystick");
  console.log('joystick', stick)
  stick.addEventListener("touchstart", handleMouseDown); //当用户触摸屏幕时触发
  document.addEventListener("touchmove", handleMouseMove); //当用户在屏幕上滑动时触发
  document.addEventListener("touchend", handleMouseUp); //当用户从屏幕上抬起手指时触发

  let dragStart = null;
  let currentPos = {
    x: 0,
    y: 0
  };

  function handleMouseDown(event) {
    event.preventDefault();
    stick.style.transition = "0s";

    if (event.changedTouches) {
      dragStart = {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY,
      };

      return;
    }
    dragStart = {
      x: event.clientX,
      y: event.clientY,
    };
  }

  function handleMouseMove(event) {
    if (dragStart === null) return;

    //console.log("entered handleMouseMove");
    if (event.changedTouches) {
      event.clientX = event.changedTouches[0].clientX;
      event.clientY = event.changedTouches[0].clientY;
      //touchEvent(currentPos);
    }

    const xDiff = event.clientX - dragStart.x;
    const yDiff = event.clientY - dragStart.y;
    const angle = Math.atan2(yDiff, xDiff);
    const distance = Math.min(maxDiff, Math.hypot(xDiff, yDiff));
    const xNew = distance * Math.cos(angle);
    const yNew = distance * Math.sin(angle);
    stick.style.transform = `translate3d(${xNew}px, ${yNew}px, 0px)`;
    currentPos = {
      x: xNew,
      y: yNew
    };
    this_.touchEvent(currentPos);
  }

  function handleMouseUp(event) {
    if (dragStart === null) return;
    stick.style.transition = ".2s";
    stick.style.transform = `translate3d(0px, 0px, 0px)`;
    dragStart = null;
    currentPos = {
      x: 0,
      y: 0
    };
    this_.moveDirection.forward = 0;
    this_.moveDirection.left = 0;
    this_.moveDirection.right = 0;
    this_.moveDirection.back = 0;
    this_.handleMouseUp()
  }

  parent.appendChild(stick);
  return {
    getPosition: () => currentPos,
  };
}



// WEBPACK FOOTER //
// ./src/utils/video.js